import React from 'react';
import {
    Navbar,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import {
    Menu,
    MenuItem,
    MenuButton,
    SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import '../styles/LearningSubHeader.css';
import {menuPart1Items, menuPart2Items} from '../LearningApp/navigationConfig'

class LearningSubHeader extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.renderSubmenu = this.renderSubmenu.bind(this);
        this.state = {
            isOpen: false
        };
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    renderSubmenu = (menuItems, part) => {
        return menuItems.map(({menuItemTitle, subMenuItems}, index) => (
            <SubMenu label={menuItemTitle} key={index}>
                {
                    subMenuItems.map(({title, id}, subIndex) => (
                        <MenuItem key={subIndex} href={`/mokomoji-priemone/${part}/${id}`}>{title}</MenuItem>
                    ))
                }
            </SubMenu>
        ))
    }

    render() {
        return (
            <div>
                <Navbar className="logo-color" expand="md">
                    <Nav className="mr-auto" navbar>
                        <NavItem>
                            <NavLink className="text-white" href="/mokomoji-priemone/apie">Apie mokomąją priemonę</NavLink>
                        </NavItem>
                        <Menu menuButton={<MenuButton>I. Kolokacijų mokymas(is)</MenuButton>}>
                            {this.renderSubmenu(menuPart1Items, "1-dalis")}
                        </Menu>
                        <Menu menuButton={<MenuButton>II. Kolokacijų vertimas</MenuButton>}>
                            {this.renderSubmenu(menuPart2Items, "2-dalis")}
                        </Menu>
                    </Nav>
                </Navbar>
            </div>
        );
    }
}

export default LearningSubHeader;
